import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//import HttpApi from 'i18next-http-backend'
import { ar, en } from './locales';
import { initReactI18next } from 'react-i18next'

const options = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  debug: false,
  supportedLngs: ['en', 'ar'],
  fallbackLng: 'en',

  resources: {
    ar: {
      common: ar,
    },
    en: {
      common: en,
    },
  },

  ns: ['common'],

  defaultNS: 'common',

  react: {
    // wait: false,
    // bindI18n: 'languageChanged loaded',
    // bindStore: 'added removed',
    // nsMode: 'default'
    bindI18n:'languageChanged',
    bindStore:'',
    transEmptyNodeValue:'',
    transSupportBasicHtmlNodes:true,
    transKeepBasicHtmlNodesFor:['br','strong','i'],
    useSuspense:true


  },
  detection: {
    order: ['path', 'cookie', 'htmlTag'],
    caches: ['cookie'],
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
//  .use(HttpApi)
  .init(options);

export default i18n;